import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams, NavLink } from "react-router-dom";
import { Nav, Navbar, Container, Button } from "react-bootstrap";

import AuthContext from "../../Context/authContext";
import { getOwnerSpots } from '../../Services/api';
import { removeFromStore } from "../../Utils/storage-helpers";
import logoWithColoredTxt from "../../Assets/Images/logo/logoWithColoredTxt-removebg-preview.png";

import "./style.scss";
const defaultNavLinkColor = { color: "#41889A" };

export const SpotNavBar = () => {
  const getNavLinkClassName = ({ isActive }) => `pe-5 spotNavLinks ${isActive ? 'active' : ''}`;
  const [spotName, setSpotName] = useState("");
  const { user: owner, isAuthenticated, setAuth } = useContext(AuthContext);
  let { id: spotId } = useParams();

  const getSpot = useCallback(async () => {
    const resp = await getOwnerSpots(owner.id, spotId);
    if (resp.status === 200) {
      const selectedSpot = resp.data;
      setSpotName(selectedSpot.name);
    }
  }, [owner, spotId]);

  const handleLogout = (event) => {
    event.preventDefault();
    removeFromStore("accessToken");
    removeFromStore("user");
    setAuth(false);
  }

  useEffect(() => {
    if ((owner && Object.keys(owner).length)) {
      getSpot();
    }
  }, [getSpot, owner]);

  return (
    <Navbar expand="sm" fixed="top" id="spotNavBar">
      <Container>
        <Navbar.Brand as="h5" className="fw-bold">{spotName}</Navbar.Brand>
        <Navbar.Toggle aria-controls="spot-navbar" />
        <Navbar.Collapse id="spot-navbar">
          <Nav className="ms-auto gap-3">
            <NavLink to="/dashboard" className={getNavLinkClassName}>Dashboard</NavLink>
            <NavLink to="staff" className={getNavLinkClassName}>Staff</NavLink>
            <NavLink to="menu" className={getNavLinkClassName}>Menu</NavLink>
            <NavLink to="tab-history" className={getNavLinkClassName}>History</NavLink>
            <NavLink to="account" className={getNavLinkClassName}>Account</NavLink>
            <NavLink to="wallet" className={`${getNavLinkClassName} pe-0 d-none`} hidden={true}>Wallet</NavLink>
            <NavLink to="/profile" className={getNavLinkClassName} hidden={true}>Profile</NavLink>
            <button type="button" className={`btn btn-link ${getNavLinkClassName} p-0 text-start`} onClick={handleLogout}>Logout</button>
            {!isAuthenticated && (
              <NavLink to="login" className={getNavLinkClassName}>Login</NavLink>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
};

const NavBar = props => {
  const { navLogo, navStyle, navLinkTextStyle } = props;
  const defaultNavStyle = {
    backgroundColor: "#ffffffd9",
    borderColor: "rgba(231, 231, 231, 0)",
    boxShadow: "0 0 10px rgb(0 0 0 / 15%)",
    padding: "20px",
  }
  const logo = navLogo || logoWithColoredTxt;
  const navBarStyle = { ...defaultNavStyle, ...navStyle };
  const linkStyle = navLinkTextStyle || defaultNavLinkColor
  const { setAuth, isAuthenticated, isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    removeFromStore("accessToken");
    removeFromStore("user");
    setAuth(false);
  }

  return (
    <Navbar expand="sm" fixed="top" id="menu" style={navBarStyle}>
      <Navbar.Brand href="/">
        <img
          src={logo}
          width="90"
          height="30"
          className="d-inline-block align-top"
          alt="Jamlyf logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="main-navbar" className="navbarToggle"/>
      <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto">
            {isAuthenticated && isAdmin ? (
              <>
                <Nav.Link href="/dashboard" className="pe-5 navLinkText page-scroll" style={linkStyle}>Dashboard</Nav.Link>
                <button
                  type="button"
                  className="btn btn-link pe-5 navLinkText page-scroll nav-link text-start"
                  onClick={handleLogout}
                  style={linkStyle}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Nav.Link href="/" className="pe-5 navLinkText page-scroll" style={linkStyle}>Home</Nav.Link>
                <Nav.Link href="#about" className="pe-5 navLinkText page-scroll" style={linkStyle}>About us</Nav.Link>
                <Nav.Link href="#support" className="pe-5 navLinkText page-scroll" style={linkStyle}>Support</Nav.Link>
                <Nav.Link href="/business" className="pe-5 navLinkText page-scroll" style={linkStyle}>Let's do Business</Nav.Link>
                {!isAuthenticated ? (
                  <Nav.Link href="/login" className="pe-5 navLinkText page-scroll" style={linkStyle}>Login</Nav.Link>
                ) : (
                  <button
                    type="button"
                    className="btn btn-link pe-5 navLinkText page-scroll nav-link text-start"
                    onClick={handleLogout}
                    style={linkStyle}
                  >
                    Logout
                  </button>
                )}
                <Button className="getApp">Get the app</Button>
              </>
            )}
          </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar;
